import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  HostListener,
} from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { SummaryDetails, TripItem } from 'src/app/model';
import { MatDialog } from '@angular/material/dialog';
import { OptimizationSummaryComponent } from '../../pop-overs/optimization-summary/optimization-summary.component';
import { TripSegmentPopoverComponent } from '../../pop-overs/trip-segment-popover/trip-segment-popover.component';
import { ServicecallService } from 'src/app';
import { ApiConstants } from 'src/app/constants/api-constants';
import { EntitiesServiceService } from 'src/app/shared/services';
export interface TripSegmentData {
  battery: {
    startRange: number;
    currentRange: number;
    lowBatteryWarning?: boolean;
  };
  insights: {
    ecoPerformance?: string;
    routeOptimization?: string;
  };
  selectedTripDetails: TripItem;
  summaryData: SummaryDetails;
}
@Component({
  selector: 'app-trip-drawer',
  templateUrl: './trip-drawer.component.html',
  styleUrl: './trip-drawer.component.scss',
  animations: [
    trigger('slideInOut', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate('300ms ease-in-out'),
      ]),
      transition('* => void', [
        animate('300ms ease-in-out', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('fadeInOut', [
      state('in', style({ opacity: 1 })),
      transition('void => *', [
        style({ opacity: 0 }),
        animate('200ms ease-in-out'),
      ]),
      transition('* => void', [
        animate('200ms ease-in-out', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class TripDrawerComponent implements OnInit, OnDestroy {
  @Input() isOpen = false;
  @Input() summaryData;
  @Input() tripData: TripItem[] = [];
  @Input() title = 'AI Assist – Trip 0011';
  @Input() subtitle = 'Drive Recommendations';
  @Output() closeDrawer = new EventEmitter<void>();
  @Output() itemClick = new EventEmitter<TripItem>();
  private _selectedTrip : TripItem;
  token: any = ApiConstants.blobSasToken;
  private _tenantConfig: any;
  constructor(private _dialog: MatDialog, private _sharedService: ServicecallService, private _entitiesService : EntitiesServiceService) {}

  ngOnInit(): void {
    if (this.isOpen) {
      document.body.style.overflow = 'hidden';
    }
  }

  ngOnDestroy(): void {
    document.body.style.overflow = 'auto';
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent): void {
    if (this.isOpen) {
      this.onClose();
    }
  }

  onClose(): void {
    document.body.style.overflow = 'auto';
    this.closeDrawer.emit();
  }

  onBackdropClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }

  onItemClick(item: TripItem, tripName: string): void {
    const selectedTrip = { ...item, id: tripName };
    this._selectedTrip = selectedTrip;
    this.itemClick.emit(selectedTrip);  
  }

  trackByFn(index: number, item: TripItem): string {
    return item.tripId;
  }

  getTripLabel(index: number): string {
    return 'T' + (index + 1)?.toString()?.padStart(4, '0');
  }

  openPopover(templateType: string) {
    if (templateType === 'optimizationSummary') {
      this._tenantConfig = this._sharedService?.getConfiguration('tenantGenericConfig')
        ? this._sharedService?.getConfiguration('tenantGenericConfig')
        : null;
      const configBasedOnCategory = this._sharedService.getConfigurationBasedOnCategory(this.summaryData?.entityDetails);
      const defaultImage = configBasedOnCategory ? configBasedOnCategory?.defaultImage : this._tenantConfig?.defaultImage;
      const defaultImageVot = this._tenantConfig?.defaultImage ? this._tenantConfig?.defaultImage?.[this.summaryData?.entityDetails?.category] : '';
      this._dialog.open(OptimizationSummaryComponent, {
        width: '60%',
        data: {
          tile1: {
            tripName: this.summaryData?.tripName ?? null,
            entityName: this.summaryData?.entityName ?? null,
            tripStartDate: this.summaryData?.tripStartDate ?? null,
            startLocation: this.summaryData?.startLocation ?? null,
            tripEndDate: this.summaryData?.tripEndDate ?? null,
            endLocation: this.summaryData?.endLocation ?? null,
            startTime : this.summaryData?.startTime ?? null,
            endTime : this.summaryData?.endTime ?? null,
            distanceTravelled: this.summaryData?.distanceTravelled ?? null,
            timeTaken: this.summaryData?.timeTaken ?? 0,
            avgSpeed: this.summaryData?.tripDetails?.avgSpeed ?? null,
            topSpeed: this.summaryData?.tripDetails?.topSpeed ?? null,
            remainingRange: null,
            tags: this.summaryData?.tags,
            imageUrl: this.summaryData?.entityDetails?.image ?? (defaultImageVot ? defaultImageVot+this.token : (defaultImage ? defaultImage+this.token : this._entitiesService.getDefaultImageByCategory(this.summaryData?.entityDetails?.category))),
            entityId: this.summaryData?.entityId,
            tripId: this.summaryData?.tripId,
            selectedDate : this.summaryData?.selectedDate,
            aggregateDate: this.summaryData?.aggregateDate
          },
        },
        disableClose: true,
      });
    } else if (templateType === 'tripSegment') {
      const tripData: TripSegmentData = {
        battery: {
          startRange: 285,
          currentRange: 283,
          lowBatteryWarning: true,
        },
        insights: {
          ecoPerformance:
            'Your smooth acceleration saved ~4% battery this segment.',
          routeOptimization:
            'Consider Highway 101 for 8% faster travel time next trip.',
        },
        selectedTripDetails: this._selectedTrip,
        summaryData: this.summaryData
      };
      this._dialog.open(TripSegmentPopoverComponent, {
        width: '60%',
        data: tripData,
        disableClose: true,
      });
    }
  }
}
